import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Col from 'component/utils/Col'
import Form from 'component/utils/Form'
import Field from 'component/utils/Field'
import DatePicker from 'component/utils/DatePicker'
import CompanySelect from 'component/branch/CompanySelect'

class PeriodPickerLmExpress extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    fetchLmExpress: PropTypes.func.isRequired,
    setValueToField: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
    fields: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      dtStart: null,
      dtEnd: null,
    }

    this.handleChangeStartDate = this.handleChangeStartDate.bind(this)
    this.handleChangeEndDate = this.handleChangeEndDate.bind(this)
    this.handleFetchLmExpress = this.handleFetchLmExpress.bind(this)
  }

  handleChangeStartDate(event) {
    const { setValueToField } = this.props

    this.setState({ dtStart: event })

    const dateFormated = event.format('DD/MM/YYYY')

    setValueToField('dtStart', dateFormated)
  }

  handleChangeEndDate(event) {
    const { setValueToField } = this.props

    this.setState({ dtEnd: event })

    const dateFormated = event.format('DD/MM/YYYY')

    setValueToField('dtEnd', dateFormated)
  }

  handleFetchLmExpress(event) {
    event.preventDefault()

    const { fetchLmExpress, values } = this.props

    fetchLmExpress(values)
  }

  handleChangeBranch = (event) => {
    const { fields } = this.props
    fields.idBranch.input.onChange(event)
  }

  render() {
    const {
      translate,
      fields,
      auth: { user },
    } = this.props

    return (
      <form
        onSubmit={this.handleFetchLmExpress}
        className='lmexpress-page container-mobile'
      >
        <div className='margin-left-double margin-right-double center-select-date'>
          <Col xs={12} className='margin-bottom-double padding-bottom-double'>
            <Col xs={12} className='margin-bottom-small'>
              <h3 className='name color-text'>
                {translate('mobile.olderLmExpress')}
              </h3>
            </Col>

            <Col xs={12}>
              <span className='gray-label'>{translate('lmexpress.hint')}</span>
            </Col>

            {user.locationCode === '999' && (
              <Col xs={12}>
                <Field
                  {...fields.idBranch}
                  error={translate(fields.idBranch.error)}
                  hint={translate('lmexpress.idBranch')}
                  icon='glyph glyph-clock'
                >
                  <CompanySelect
                    {...fields.idBranch.input}
                    onChange={this.handleChangeBranch}
                  />
                </Field>
              </Col>
            )}

            <Col xs={12} sm={6} md={4}>
              <Field
                {...fields.dtStart}
                error={translate(fields.dtStart.error)}
                glyph='glyph glyph-calendar'
                validate
              >
                <DatePicker
                  date={this.state.dtStart}
                  onDateChange={this.handleChangeStartDate}
                  placeholder={translate('lmexpress.from')}
                  isOutsideRange
                />
              </Field>
            </Col>

            <Col xs={12} sm={6} md={4}>
              <Field
                {...fields.dtEnd}
                error={translate(fields.dtEnd.error)}
                glyph='glyph glyph-calendar'
                validate
              >
                <DatePicker
                  date={this.state.dtEnd}
                  onDateChange={this.handleChangeEndDate}
                  placeholder={translate('lmexpress.to')}
                  isOutsideRange
                />
              </Field>
            </Col>

            <Col xs={12} sm={6} md={3} className='margin-top-one-point-seven'>
              <button
                type='submit'
                className='button button-primary button-full'
              >
                {translate('lmexpress.filter')}
              </button>
            </Col>
          </Col>
        </div>
      </form>
    )
  }
}

const fields = ['idBranch', 'dtStart', 'dtEnd']

export default Form({ fields })(PeriodPickerLmExpress)

export { PeriodPickerLmExpress }
